export const suggestionAttachmentType = 'suggestion';

type OptionWithAction = {
  text: string;
  request_path?: string;
  method?: 'get' | 'post' | 'put';
};

export type SuggestionAttachmentProps = {
  type: 'suggestion';
  options?: Array<string | OptionWithAction>;
};

function optionText(option: string | OptionWithAction): string {
  return typeof option === 'string' ? option : option.text;
}

export function SuggestionAttachment({ options }: SuggestionAttachmentProps) {
  if (!options?.length) return null;

  return (
    <div className="str-chat__message-attachment str-chat__message-attachment--suggestion">
      {options.map((option, index) => (
        <button
          key={index}
          type="button"
          disabled
          className="str-chat__attachment-actions-button"
        >
          {optionText(option)}
        </button>
      ))}
    </div>
  );
}
